<template>
    <v-container>
        <v-card class="ma-3">
            <v-tabs v-model="tab" grow>
                <v-tab>Special Level Assets</v-tab>
                <v-tab>Collect Item</v-tab>
            </v-tabs>
            <v-card class="ma-3">
                <v-tabs-items v-model="tab" class="mt-3" flat>
                    <v-tab-item>
                        <tiletravel-special-level-assets/>
                    </v-tab-item>
                    <v-tab-item>
                        <tiletravel-collect-item-assets/>
                    </v-tab-item>
                </v-tabs-items>
            </v-card>
        </v-card>
    </v-container>
</template>

<script>
import TileTravelSpecialLevelAssets from '@/components/tiletravel/TileTravelSpecialLevelAssets.vue'
import TileTravelCollectItemAssets from '@/components/tiletravel/TileTravelCollectItemAssets.vue'

export default ({
    name: "TileTravel",
    components: {
        'tiletravel-special-level-assets': TileTravelSpecialLevelAssets,
        'tiletravel-collect-item-assets': TileTravelCollectItemAssets,
    },
    data: function(){
        return {
            tab: null,
        }
    },
})
</script>

<style>
.v-tab {
    text-transform: none !important;
}
</style>
